export default __webpack_public_path__ + "static/media/grunge_border.9f161d86.png";